module.exports = __webpack_public_path__ + "static/media/logo-dataak-header.15599296.svg";